<template>
  <v-container fluid>
    <v-layout justify-center align-center v-if="isLoading">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <div class="title pa-3">{{ $t('searching_account') }}</div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center v-if="!isLoading">
      <v-flex xl6 lg6 md8 sm10 xs12>
        <h3 class="pt-5 pb-5">Communication Settings</h3>
        <v-list
          flat
          subheader
          three-line
        >
          <v-subheader>
            <h3>Email Messages for {{ data.name }}</h3>
          </v-subheader>
          <v-divider />

          <v-list-item-group
            v-model="settings.email"
            multiple
            active-class=""
          >
            <v-list-item value="e-billing">
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>e-Billing</v-list-item-title>
                  <v-list-item-subtitle>Important messages related to your assessment accounts or billing.</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>

            <v-list-item value="updates">
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>e-Services Updates</v-list-item-title>
                  <v-list-item-subtitle>New and enhanced features and tips for getting the most out of the e-Services</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>

            <v-list-item value="surveys">
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>Surveys</v-list-item-title>
                  <v-list-item-subtitle>Make your opinions heard! Give us feedback on how to make e-Services a better service for you.</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-layout class="row justify-space-around" pt-5>
          <v-btn v-if="!!hasSession" :block="$vuetify.breakpoint.xsOnly" color="primary" large rounded @click.prevent="submit" :disabled="!!this.errors.any() || isLoading" :loading="isLoading">{{ $t('update') }}</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  data: () => ({ settings: { email: [] } }),
  computed: {
    ...mapGetters({
      hasSession: 'auth/hasSession',
      isLoading: 'auth/isLoading'
    }),
    ...mapState({
      data: (state) => state.auth.data
    })
  },
  created: async function () {
    if (this.$store.getters['auth/hasName']) {
      this.$store.commit('form/setId', { id: this.$store.getters['auth/hasName'] })
      await this.$store.dispatch('form/fetchData')
    }
    const response = await this.$store.dispatch('auth/session')
    if (response.userCtx.name === '' || response.userCtx.name === 'couchdb' || !this.data) {
      this.$router.push('/')
      this.$store.dispatch('snackbar/setSnackBar', {
        color: 'error',
        message: 'Pengguna tidak dijumpai. Sila log masuk semula.',
        visible: true
      })
    }
  },
  methods: {
    async submit () {
      await this.$store.dispatch('form/fetchData')
      await this.$store.dispatch('form/updateCommunication', { subscriptions: this.settings.email })
    }
  }
}
</script>
